// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalActionsButton__icon-cf8dc7 {
  transform: rotate(90deg);
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SecretChatRequestAccessPopup/components/GlobalActionsButton/GlobalActionsButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,oBAAA;AACF","sourcesContent":[".icon {\n  transform: rotate(90deg);\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `GlobalActionsButton__icon-cf8dc7`
};
module.exports = ___CSS_LOADER_EXPORT___;
